import { z } from 'zod';
import { SHEET_DESCRIPTION_MAX, SHEET_NAME_MAX } from '../constants/limits.js';
import { SHEET_ICONS } from '../types/sheet.js';
const HexColor = z.string().regex(/^#([0-9a-f]{3}|[0-9a-f]{6})$/i, 'Must be a hex color');
export const CreateFolderRequestSchema = z.object({
    name: z.string().min(1).max(SHEET_NAME_MAX),
    description: z.string().max(SHEET_DESCRIPTION_MAX).optional(),
    icon: z.enum(SHEET_ICONS).optional(),
    accentColor: HexColor.optional(),
    folderUrl: z.string().min(1).max(2_000),
});
export const UpdateFolderRequestSchema = z
    .object({
    name: z.string().min(1).max(SHEET_NAME_MAX).optional(),
    description: z.string().max(SHEET_DESCRIPTION_MAX).nullable().optional(),
    icon: z.enum(SHEET_ICONS).nullable().optional(),
    accentColor: HexColor.nullable().optional(),
    folderUrl: z.string().min(1).max(2_000).optional(),
    isActive: z.boolean().optional(),
})
    .refine((data) => Object.keys(data).length > 0, {
    message: 'At least one field must be provided',
});
export const FolderIdParamSchema = z.object({ id: z.string().uuid() });
export const FolderUserParamSchema = z.object({
    id: z.string().uuid(),
    userId: z.string().uuid(),
});
export const GrantFolderBodySchema = z.object({ folderId: z.string().uuid() });
export const GrantFolderUserBodySchema = z.object({ userId: z.string().uuid() });
//# sourceMappingURL=folder.schema.js.map